import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

// Custom iOS-style MUI Switch that accepts a dynamic fillColor prop
const IOSSwitch = styled((props) => {
  const { fillColor, ...other } = props; // extract fillColor before passing props to Switch
  return <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...other} />;
})(({ theme, fillColor }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: fillColor || "#65C466", // <-- dynamic color
        opacity: 1,
        border: 0,
        ...(theme.palette.mode === "dark" && {
          backgroundColor: fillColor || "#2ECA45",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...(theme.palette.mode === "dark" && {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...(theme.palette.mode === "dark" && {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#B0BEC5",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...(theme.palette.mode === "dark" && {
      backgroundColor: "#39393D",
    }),
  },
}));

function ToggleSwitch({ checked, onChange, disabled = false, showText = true, fillColor }) {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <IOSSwitch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        fillColor={fillColor}
      />
      {showText && (
        <Typography variant="body2" color={disabled ? "text.disabled" : "text.primary"}>
          {checked ? "Yes" : "No"}
        </Typography>
      )}
    </Box>
  );
}

export default ToggleSwitch;
